module.exports = "<div style=\"padding: 5px; \">\n  <ax-hour-heat-map [title]='title' [detector]=\"id\" [name]=\"id\"></ax-hour-heat-map>\n</div>"